module.exports = __webpack_public_path__ + "img/img_32389_0_474.fbbfec6e.png";